import script from "./gate.vue?vue&type=script&setup=true&lang=js"
export * from "./gate.vue?vue&type=script&setup=true&lang=js"

import "./gate.vue?vue&type=style&index=0&id=3e79c673&lang=scss"

const __exports__ = script;

export default __exports__